import { ResolveStrategy } from './changeObjectPropertyByJmespath'

const mapStrategyByReferenceResoveMethod = {
  MERGE: 'mergePreferPatch',
  MERGE_PREFER_PATCH: 'mergePreferPatch',
  MERGE_PREFER_BASE: 'mergePreferBase',
  REPLACE: 'replace',
  REPLACE_PREFER_PATCH: 'replacePreferPatch',
  REPLACE_PREFER_BASE: 'replacePreferBase',
} as const satisfies Record<string, ResolveStrategy>

export function getStrategyByReferenceMethod(
  referenceMethod: keyof typeof mapStrategyByReferenceResoveMethod,
) {
  return mapStrategyByReferenceResoveMethod[referenceMethod]
}

const mapReferenceResoveMethodByStrategy = {
  replace: 'REPLACE_PREFER_PATCH',
  replacePreferPatch: 'REPLACE_PREFER_PATCH',
  replacePreferBase: 'REPLACE_PREFER_BASE',
  mergePreferPatch: 'MERGE_PREFER_PATCH',
  mergePreferBase: 'MERGE_PREFER_BASE',
} as const satisfies Record<ResolveStrategy, string>

export function getReferenceMethodByStrategy(strategy: ResolveStrategy) {
  return mapReferenceResoveMethodByStrategy[strategy]
}
